import { React, useContext, useState, forwardRef, useImperativeHandle } from 'react';
import '../../css/Layout.css';
import Button from "@mui/material/Button";
import { FiMenu } from "react-icons/fi";
import { IoMdClose, IoMdMegaphone } from "react-icons/io";
import { RiLogoutBoxRLine } from "react-icons/ri";
import { VscQuestion } from "react-icons/vsc";
import { FaArrowLeft } from "react-icons/fa6";
import { RiPoliceBadgeLine } from "react-icons/ri";
import { CgProfile } from "react-icons/cg";
import { MdMenuBook } from "react-icons/md";
import { RiChatAiLine } from "react-icons/ri";
import { useNavigate, Outlet } from "react-router-dom";
import axios from "axios";
import Nav from './Nav'

// 🚨 태블릿용 네비게이션 임포트 추가
import TAB_Nav from './TAB_Nav'

import LicenseModal from '../../common/LicenseModal';
import QuestionModal from '../../common/QuestionModal';
import ProfileModal from '../../common/ProfileModal';
import ChatModal from '../../common/ChatModal';

export const Header = ((ref) => {
  const navigate = useNavigate();
  const [navFlag, setNavFlag] = useState(false);
  const [isLicenseModalOpen, setLicenseModalOpen] = useState(false);
  const [isQuestionModalOpen, setQuestionModalOpen] = useState(false);
  const [isProfileModalOpen, setProfileModalOpen] = useState(false);
  const [isChatModalOpen, setChatModalOpen] = useState(false);
  
  // 현재 접속한 디바이스 타입 ('P': PC, 'T': 태블릿, 'M': 모바일 등)
  const deviceType = localStorage.getItem("deviceType") || 'P';
  const isTablet = deviceType === 'T';

  const handleNavFlag = () => {
    setNavFlag(!navFlag);
  };

  const handleNavFlagFalse = () => {
    setNavFlag(false);
  };

  const handleLogout = () => {
    localStorage.setItem("LogoutType", 'C');
    navigate("/Logout");
  };

  const handleManual = async () => {
    // 태블릿이면 동작하지 않음
    if (isTablet) return;

    const fileUrl = '/MES%20User%20Manual.pptx';

    try {
      const checkRes = await fetch(fileUrl, { method: 'HEAD' });

      if (checkRes.ok) {
        console.log("로컬(public)에서 매뉴얼을 다운로드합니다.");
        const link = document.createElement('a');
        link.href = fileUrl;
        link.setAttribute('download', 'MES User Manual.pptx');
        document.body.appendChild(link);
        link.click();
        link.remove();
      } else {
        console.log("로컬에 파일이 없어 내부에서 다운로드를 시도합니다.");
        await downloadFromBackend();
      }
    } catch (e) {
      console.log("로컬 체크 중 에러 발생. 내부경로로 시도합니다.");
      await downloadFromBackend();
    }
  };

  const downloadFromBackend = async () => {
    try {
      const res = await axios.get('/api/Common/ManualDown', { 
        responseType: 'blob' 
      });

      const cd = res.headers['content-disposition'] || res.headers['Content-Disposition'] || '';
      let filename = 'MES_사용자_매뉴얼.pptx'; 

      if (cd) {
        let m = cd.match(/filename\*=UTF-8''([^;]+)/i);
        if (m && m[1]) {
          filename = decodeURIComponent(m[1]);
        } else {
          m = cd.match(/filename="([^"]+)"/i) || cd.match(/filename=([^;]+)/i);
          if (m && m[1]) filename = m[1];
        }
      }

      const blob = new Blob([res.data], { type: 'application/vnd.openxmlformats-officedocument.presentationml.presentation' });
      const url  = window.URL.createObjectURL(blob);
      const a    = document.createElement('a');
      
      a.style.display = 'none';
      a.href = url;
      a.download = filename;
      
      document.body.appendChild(a);
      a.click();
      
      setTimeout(() => { 
        window.URL.revokeObjectURL(url); 
        document.body.removeChild(a); 
      }, 100);

    } catch (err) {
      console.error("백엔드 다운로드 실패:", err);
      alert('파일을 찾을 수 없거나 다운로드에 실패했습니다.');
    }
  };

  const goToMain = () => {
    return navigate(localStorage.getItem("main"));
  };

  const licenseModalClose = () => {
    setLicenseModalOpen(false);
  }

  const questionModalClose = () => {
    setQuestionModalOpen(false);
  }

  const profileModalClose = () => {
    setProfileModalOpen(false);
  }

  const chatModalOpen = () => {
    setChatModalOpen(true);
  };

  const chatModalClose = () => {
    setChatModalOpen(false);
  };

  return (
    <>
    <header className="header">
        <div style={ { width: '100%' } }>
        
        {(deviceType === "A" || deviceType === "I" || deviceType === "M") ? 
        <div className="NavIcon" onClick={handleNavFlag}>  {navFlag? (<FaArrowLeft size="30" />) : (<FiMenu size="30" />)}</div>
        :
        <div className="NavIcon" onClick={handleNavFlag}>  {navFlag? (<FaArrowLeft size="45" />) : (<FiMenu size="45" />)}</div>}
        &nbsp;&nbsp;
        {(deviceType === "A" || deviceType === "I" || deviceType === "M") ? 
        <div onClick={goToMain} className="CompnayNM" style={ { paddingTop: '8px' } }>{ localStorage.getItem("company_nm") }</div>
        :
        <div onClick={goToMain} className="CompnayNM">{ localStorage.getItem("company_nm") }</div>}
        
        <div className="HeaderFunction">
          <div className="UserNM">{ localStorage.getItem("user_nm") }</div>
          <div className="ResourceNM">{ (localStorage.getItem("resource_name") !== '')? localStorage.getItem("resource_name"):"" }</div>
          <div className="BtnSet">
            <Button 
              onClick={()=> { setProfileModalOpen(true) }}
              sx={{  
                m: 1, 
                fontSize: 15, 
                color: "black", 
                borderColor: "black", 
                ":hover": { borderColor: "BLACK", backgroundColor: "BLACK", color: "white" }, 
              }} 
              variant="outlined" 
              startIcon={<CgProfile />}>
              프로필 수정
            </Button>

            {/* 태블릿이 아닐 때만 1:1 문의 버튼 표시 */}
            {!isTablet && (
              <Button 
                onClick={()=> { setQuestionModalOpen(true) }}
                sx={{  
                  m: 1, 
                  fontSize: 15, 
                  color: "black", 
                  borderColor: "black", 
                  ":hover": { borderColor: "#FFBB00", backgroundColor: "#FFBB00", color: "white" }, 
                }} 
                variant="outlined" 
                startIcon={<VscQuestion />}>
                1:1문의
              </Button>
            )}
            
            {/* 태블릿이 아닐 때만 매뉴얼 버튼 표시 */}
            {!isTablet && (
              <Button 
                onClick={() => { setLicenseModalOpen(true) }}
                sx={{  
                  m: 1, 
                  fontSize: 15, 
                  color: "black", 
                  borderColor: "black", 
                  cursor: "pointer",
                  ":hover": { borderColor: "#3D63AE", backgroundColor: "#3D63AE", color: "white" }, 
                }} 
                variant="outlined" 
                startIcon={<RiPoliceBadgeLine />}>
                라이센스
              </Button>
            )}
            
            {/* 태블릿이 아닐 때만 매뉴얼 버튼 표시 */}
            {!isTablet && (
              <Button 
                onClick={handleManual}
                sx={{  
                  m: 1, 
                  fontSize: 15, 
                  color: "black", 
                  borderColor: "black", 
                  ":hover": { borderColor: "#40940fff", backgroundColor: "#40940fff", color: "white" }, 
                }} 
                variant="outlined" 
                startIcon={<MdMenuBook />}>
                매뉴얼
              </Button>
            )}
            
            <Button 
              onClick={chatModalOpen}
              sx={{  
                m: 1, 
                fontSize: 15, 
                color: "black", 
                borderColor: "black", 
                ":hover": { borderColor: "#aa1291ff", backgroundColor: "#aa1291ff", color: "white" }, 
              }} 
              variant="outlined" 
              startIcon={<RiChatAiLine />}>
              AI챗봇
            </Button>

            <Button 
                onClick={handleLogout}
                sx={{  
                  m: 1, 
                  fontSize: 15, 
                  color: "black", 
                  borderColor: "black", 
                  ":hover": { borderColor: "#FF4848", backgroundColor: "#FF4848", color: "white" }, 
                }} 
                variant="outlined" 
                startIcon={<RiLogoutBoxRLine />}>
              로그아웃
            </Button>
          </div>
        </div>
      </div>
      {isLicenseModalOpen && (<LicenseModal licenseModalClose={licenseModalClose} />)}
      {isQuestionModalOpen && (<QuestionModal questionModalClose={questionModalClose} />)}
      {isProfileModalOpen && (<ProfileModal profileModalClose={profileModalClose} />)}
      {isChatModalOpen && (<ChatModal chatModalClose={chatModalClose} />)}
    </header>
    <div style={ { position: 'relative', overflowY: 'auto', overflowX: 'hidden', width: '100%', minHeight: 'calc(100vh - 100px)', backgroundColor : 'white' } }>
        {/* 🚨 조건 분기: 태블릿일 경우 TAB_Nav 렌더링, 아닐 경우 기존 Nav 렌더링 */}
        {isTablet ? <TAB_Nav getNavFlag={navFlag} handleNavFlagFalse={handleNavFlagFalse} /> : <Nav getNavFlag={navFlag} handleNavFlagFalse={handleNavFlagFalse} />}
        <Outlet />
    </div>
    </>
  );
});

export default Header;